import React from 'react';
import {Link} from 'react-router';
import Price from '../Price';
import InfoLabel from "../InfoLabel";
import ThemableSvgIcon from "../theme/ThemableSvgIcon";
import {getExcursionText} from "../../utils/themeUtils";
import CartElementImage from "./CartElementImage";
import { Trans, useLingui } from '@lingui/react/macro';
import { useSelector } from 'react-redux';
import capitalize from 'lodash/capitalize';


function CartElementItinerary(props) {
    const currencySymbol = useSelector(state => state.cart.currencySymbol);
    const {t} = useLingui();
    const excursionText = getExcursionText();

    return (
        <div className="flex flex-wrap bg-white shadow sm:p-4 my-4">
            {/* image */}
            <CartElementImage name={props.name} imageReference={props.imageReference} imageCategory={props.imageCategory} />

            {/* rest of card */}
            <div className="xl:flex xl:flex-col px-4 py-2 sm:p-0 w-full sm:w-1/2 md:w-3/5 xl:w-2/3 mt-2 sm:mt-0 relative sm:grow xl:grow-0 xl:pl-4">
                {/* Remove from cart */}
                <span className="text-primary cursor-pointer absolute top-0 right-0 mr-4 mt-2 sm:m-0"
                      onClick={props.remove}>
                    <span className="hidden md:inline">
                        <Trans id="cancel">Cancel</Trans>
                    </span> 
                    <ThemableSvgIcon name="x" className="w-3 h-3 inline ml-1"/>
                </span>

                {/* title link*/}
                <div className="mr-6 md:mr-16">
                    {/* linkTo can be a plain string (Excursions) or an object {pathname, state} (TAC) */}
                    <Link 
                        className="text-primary underline text-2xl uppercase sm:pr-3 md:pr-0" 
                        to={typeof props.linkTo === 'string' ? props.linkTo : props.linkTo.pathname}
                        state={typeof props.linkTo === 'string' ? undefined : props.linkTo.state}
                    >
                        {props.name}
                    </Link>
                </div>

                {/*details, change link and price info*/}
                <div className="xl:flex xl:justify-between xl:grow">
                    <div className="xl:flex xl:flex-col xl:justify-between">
                        <div>
                            {props.children}
                        </div>
                        {/* changePassengersLinkTo can be a plain string (Excursions) or an object {pathname, state} (TAC) */}
                        <Link 
                            className="text-primary underline cursor-pointer" 
                            to={typeof props.changePassengersLinkTo === 'string' ? props.changePassengersLinkTo : props.changePassengersLinkTo.pathname}
                            state={typeof props.changePassengersLinkTo === 'string' ? undefined : props.changePassengersLinkTo.state}
                        >
                            {props.changePassengersLinkText}
                        </Link>
                    </div>

                    <div className="flex flex-col items-end justify-end text-right w-full xl:w-auto mt-4 xl:mt-0">
                        <InfoLabel label={props.status === "Bookable" ? t({id: "not_reserved"}) : t({id: "waitlist_not_reserved"})} />
                        <Price 
                            classes="sm:leading-negative" 
                            preText={capitalize(t({id: "excursion_cost", message: `${excursionText} Cost`}))} 
                            price={props.price} 
                            currencySymbol={currencySymbol} 
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}


export default CartElementItinerary;